module.exports = __webpack_public_path__ + "img/Jauge_Barre.42121d31.svg";